// Single source of truth for which `notifications` document `type` values
// are recognized by BOTH the unread badge (BottomNav.js) and the
// Notification Center (NotificationsPage.js).
//
// Root cause this fixes: the backend (functions/chat/chatCore.js,
// functions/calls/startCall.js) has always created notifications with
// type "message"/"call", but the Notification Center's own allow-list
// never included them - so they counted toward BottomNav's unread badge
// forever, yet could never be opened/marked read from the Notifications
// screen, since that screen silently dropped them before they ever
// reached its own state. A type must be added here deliberately; do not
// widen either consumer's filter without adding it here too, or the same
// "permanently stuck badge" bug returns for the next new type.
export const SUPPORTED_NOTIFICATION_TYPES = [
  "follow",
  "visit",
  "gift",
  "withdraw",
  "support",
  "match",
  "message",
  "call",
];

export function isSupportedNotificationType(type) {
  return SUPPORTED_NOTIFICATION_TYPES.includes(String(type || "").trim());
}

/**
 * Counts how many Firestore QueryDocumentSnapshots (from the unread-badge
 * query in BottomNav.js: uid == me AND read == false, no type filter, to
 * avoid a new composite index) represent a supported type - i.e. a
 * notification the Notification Center can actually show and let the user
 * clear. Extracted as a pure function so the badge fix is directly
 * unit-testable without rendering BottomNav's full component tree.
 */
export function countSupportedUnread(docs) {
  return (docs || []).filter((d) =>
    isSupportedNotificationType(d.data().type)
  ).length;
}
